import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ac005ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-method item-method__container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 item-method__column" }
const _hoisted_4 = { class: "item-row" }
const _hoisted_5 = { class: "switch" }
const _hoisted_6 = ["onUpdate:modelValue", "value", "id", "onChange", "disabled"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider" }, null, -1))
const _hoisted_8 = { class: "name" }
const _hoisted_9 = ["for"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.additionalServices, (service) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            key: service.partNo
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", _hoisted_5, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": ($event: any) => ((service.isSelected) = $event),
                  value: service.partNo,
                  id: service.partNo,
                  onChange: ($event: any) => (_ctx.toggle(service.partNo)),
                  disabled: _ctx.disabled
                }, null, 40, _hoisted_6), [
                  [_vModelCheckbox, service.isSelected]
                ]),
                _hoisted_7
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", {
                  class: "label",
                  for: service.partNo
                }, _toDisplayString(service.name), 9, _hoisted_9),
                _withDirectives(_createElementVNode("span", null, _toDisplayString(_ctx.showPricesAsB2b ? service.priceFormatted : service.priceIncVatFormatted), 513), [
                  [_vShow, !_ctx.hidePrices]
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "description",
              innerHTML: service.description
            }, null, 8, _hoisted_10),
            _createElementVNode("div", {
              class: "description",
              innerHTML: service.subHeader
            }, null, 8, _hoisted_11)
          ]))
        }), 128))
      ])
    ])
  ]))
}